import _ from "lodash";
import {
  startGetAdvertiserDefaultPlatformValues,
  startSaveAdvertiserDefaultPlatformValues,
} from "../../actions/platformDefaults";

export const saveInitialPlatformDefaultsFromCampaign = async ({
  dispatch,
  platform,
  formValues,
}) => {
  const existing = await dispatch(
    startGetAdvertiserDefaultPlatformValues({ platform })
  );

  if (existing?.ok && existing.data && !_.isEmpty(existing.data)) {
    return { ok: true, skipped: true };
  }

  return dispatch(
    startSaveAdvertiserDefaultPlatformValues({
      platform,
      values: formValues,
    })
  );
};
